import {createSlice,createAsyncThunk} from "@reduxjs/toolkit";

const templatesSlice = createSlice({
    name:'templates', 
    initialState:{ 
        loading: false,
        templates :[],
        assessments :[],
        template :{},
        assessment :{},
        assessmentPass :{}
    },
    reducers:{
        add_templates:(state,action)=>{
            state.templates = action.payload
        },
        add_template:(state,action)=>{
            state.template = action.payload
        },
        add_assessments:(state,action)=>{
            state.assessments = action.payload
        },
        add_assessment:(state,action)=>{
            state.assessment = action.payload
        },
        add_assessment_pass:(state,action)=>{
            state.assessmentPass = action.payload
        },
        delete_templates:(state)=>{
            state.templates = []
        }

    }
})

export const {add_templates,add_template,delete_templates,add_assessment,add_assessments,add_assessment_pass} = templatesSlice.actions;
export default templatesSlice.reducer; 